import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import security from './../utils/security'
import localStore from './../utils/localStore'
import JsonUtils from './../utils/json'

import learingArea from '@/module-area/area'

import courseIndexTwo from '@/module-course/index-two'
import courseIndexClass from '@/module-course/index-class'
import courseIndexClassic from '@/module-course/index-classic'
import courseIndexKaoyan from '@/module-course/index-kaoyan'

import learingDataRecord from '@/module-data/record'
import learingDataAll from '@/module-data/all'
//20210326 铸魂育人改版
import learingSpirit from '@/module-spirit/index'

import learingTikuSpecialList from '@/module-tiku/tikuSpecialList'
import learingTikuSpecial from '@/module-tiku/tikuSpecial'
import learingTikuWrong from '@/module-tiku/tikuWrong'
import learingTikuCollect from '@/module-tiku/tikuCollect'
import learingTikuScore from '@/module-tiku/tikuScore'
import learingTikuRandom from '@/module-tiku/tikuRandom'
import learingCollection from '@/module-person/collection'
import learingAbout from '@/module-person/about'
import learingClassicItems from '@/module-course/classicItems'
import learingClassics from '@/module-course/classics'
import learingClass from '@/module-course/class'
import learingList from '@/module-list/index'
import learingUpdate from '@/module-person/update'
import learingPerson from '@/module-person/index'
import learingIndex from '@/module-index/index'
import learningRed from '@/module-red/index'
import learingIndexList from '@/module-index/list'
import learingIndexDetail from '@/module-index/detail'
import learingIndexPlay from '@/module-index/play'
import learingIndexPay from '@/module-index/pay'
import listIndex from '@/module-list/index'
import courseIndex from '@/module-course/index'
import courseEmpty from '@/module-course/empty'
import courseSearch  from '@/module-course/search'
import myIndex from '@/module-my/index'
import personalData from '@/module-my/personalData'
import myOrder from '@/module-my/myOrder'
import login from '@/module-my/login'
import register from '@/module-my/register'
// import learingLink from '@/module-link/index'
//引入20大/百年征程专题页面,过后不使用了在删除
import hunDred from '@/module-school100/index'
import party20 from '@/module-party20/index'
//百年芳华轮播图点击跳转的页面
import bnfhPicture from '@/module-clickbnfhPicture/index'
//东北抗联页面
// import dbkl from '@/module-dbkl/index'
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 注册路由
const router = new Router({
  
  routes: [
    {
      path: '/indexClass',                   // 铸魂育人-大学-思政微课 二级目录
      name: 'indexClass',
      component: courseIndexClass
    },
    {
      path: '/indexClassic',                   // 铸魂育人-大学-经典案例 二级目录
      name: 'indexClassic',
      component: courseIndexClassic
    },
    {
      path: '/indexKaoyan',                   // 铸魂育人-大学-考研练习 二级目录
      name: 'indexKaoyan',
      component: courseIndexKaoyan
    },


    {
      path: '/indexTwo',                   // 铸魂育人 二级目录
      name: 'indexTwo',
      component: courseIndexTwo
    },
    {
      path: '/indexTwo',                   // 铸魂育人 二级目录
      name: 'indexTwo',
      component: courseIndexTwo
    },
    {
      path: '/record',                 // 个人登录记录(学生)
      name: 'learingDataRecord',
      component: learingDataRecord
    },
    {
      path: '/all',                 // 汇总数据记录（管理员）
      name: 'learingDataAll',
      component: learingDataAll
    },
    {
      path: '/area',                 // 经典
      name: 'learingAarea',
      component: learingArea
    },
    {
      path: '/update',                 // 经典
      name: 'learingUpdate',
      component: learingUpdate
    },
    {
      path: '/tikuRandom',                 // 经典
      name: 'learingTikuRandom',
      component: learingTikuRandom
    },
    {
      path: '/about',                 // 经典
      name: 'learingAbout',
      component: learingAbout
    },
    {
      path: '/classicItem',                 // 经典二级列表
      name: 'learingClassicItems',
      component: learingClassicItems
    },
    {
      path: '/classic',                 // 经典
      name: 'learingClassics',
      component: learingClassics
    },
    {
      path: '/tikuWrong',                 // 经典
      name: 'learingTikuWrong',
      component: learingTikuWrong
    },
    {
      path: '/tikuSpecialList',                 // 
      name: 'learingTikuSpecialList',
      component: learingTikuSpecialList
    },
    {
      path: '/tikuSpecial',                 // 
      name: 'learingTikuSpecial',
      component: learingTikuSpecial
    },
    {
      path: '/tikuCollect',                 // 经典
      name: 'learingTikuCollect',
      component: learingTikuCollect
    },
    {
      path: '/tikuScore',                 // 经典
      name: 'learingTikuScore',
      component: learingTikuScore
    },
    {
      path: '/class',                 // 课程
      name: 'learingClass',
      component: learingClass
    },
    {
      path: '/personCollect',                   // 
      name: 'learingCollection',
      component: learingCollection
    },
    {
      path: '/person',                   // 个人页面
      name: 'learingPerson',
      component: learingPerson
    },
    {
      path: '/',                   // 首页
      name: 'learingList',
      component: learingList
    },
    // {
    //   path: '/index',                   // 首页
    //   name: 'learingIndex1',
    //   component: courseIndex//learingIndex
    // },
    {
      path: '/indexold',                   // 首页
      name: 'learingIndex1',
      component: courseIndex//learingIndex
    },
    {
      path: '/indexempty',                   // 首页
      name: 'learingIndex1',
      component: courseEmpty//learingIndex
    },
    {
      path: '/index',                   // 首页
      name: 'learingIndex1',
      component: learingSpirit
    },
    {
      path: '/course',                 // 课程 （我购买观看过的课程）
      name: 'learningRed',
      component: learningRed
    },
    {
      path: '/list',                   // 分类
      name: 'learingList',
      component: learingList
    },
    {
      path: '/my',                      // 我的
      name: 'myIndex',
      component: myIndex
    },
    {
      path: '/list/all',            // 列表页
      name: 'learingIndexList',
      component: learingIndexList
    },
    {
      path: '/list/all/:id',            // 列表页
      name: 'learingIndexList2',
      component: learingIndexList
    },
    {
      path: '/detail/:classId',     // 详情页
      name: 'learingIndexDetail',
      component: learingIndexDetail
    },
    {
      path: '/play/:classId',       //视频播放页
      name: 'learingIndexPlay',
      component: learingIndexPlay
    },
    {
      path: '/pay/:classId',         // 支付页
      name: 'learingIndexPay',
      component: learingIndexPay
    },
    {
      path: '/search/:searchName',      // 搜索
      name: 'courseSearch',
      component: courseSearch
    },
    {
      path: '/search/',                 // 搜索-未输入搜索词
      name: 'courseSearch2',
      component: courseSearch
    },
    {
      path: '/personalData',       // 个人资料
      name: 'personalData',
      component: personalData,
    },
    {
      path: '/login',              // 登录
      name: 'login',
      component: login,
    },
    {
      path: '/register',              // 登录
      name: 'register',
      component: register,
    },
    {
      path: '/myOrder',            // 我的订单
      name: 'myOrder',
      component: myOrder,
    },
    // {
    //   path: '/link',            // 我的订单
    //   name: 'link',
    //   component: learingLink,
    // }
    

    // //下面是新增内容
    {
      path: '/party20',                 // 20大专题
      name: 'party20',
      component:party20
    },
    {
      path: '/centennialpolicy',             // 百年征程专题
      name: 'hunDred',
      component: hunDred
    },
    //新增一个百年芳华轮播图点击跳转页面
    {
      path: '/bnfhpicture',            // 我的订单
      name: 'bnfhpicture',
      props: true ,
      component: bnfhPicture,
    },
    // //新增东北抗联页面
    // {
    //   path: '/dbkl',            // 我的订单
    //   name: 'dbkl',
    //   props: true ,
    //   component: dbkl,
    // },


  ]
})

// 路由权限控制
router.beforeEach((to, from, next) => {
  
  // //跳转外链
  // if(store.state.mineStore.back!=undefined){
  //   console.log("外链返回");
  //   store.state.mineStore.selected=store.state.mineStore.back;
  //   store.state.mineStore.back=undefined;
  // }
  let user = store.state.mineStore.uid
  if (!user) {
    let tmp = localStore.getItem('mobUser', null)
    user = tmp === null ? null : JsonUtils.stringToJson(tmp)
    store.commit('save', user)
  }
  if (to.path === '/register'){
    next()
    return
  }
  //wyk权限控制
  
  if(to.path=="/"){
    store.state.mineStore.selected="list";
  }else{
    var path=to.path;
    //需要改回来的注释，这里替换了
    // if(path.indexOf("/index")==-1&&path.indexOf("/list")==-1&&path.indexOf("/my")==-1&&path.indexOf("/course")==-1){
    //   store.state.mineStore.selected="";
    // }
    // if(path.indexOf("/index")!=-1||path.indexOf("/list")!=-1||path.indexOf("/my")!=-1||path.indexOf("/course")!=-1){
    //   store.state.mineStore.selected=path.split("/")[1];
    // }
    if(path.indexOf("/index")==-1&&path.indexOf("/list")==-1&&path.indexOf("/my")==-1&&path.indexOf("/course")==-1&&path.indexOf("/party20")==-1&&path.indexOf("/centennialpolicy")==-1){
      store.state.mineStore.selected="";
    }
    if(path.indexOf("/index")!=-1||path.indexOf("/list")!=-1||path.indexOf("/my")!=-1||path.indexOf("/course")!=-1||path.indexOf("/party20")!=-1||path.indexOf("/centennialpolicy")!=-1){
      store.state.mineStore.selected=path.split("/")[1];
    }

    console.log("store.state.mineStore.selected is:");
    console.log(store.state.mineStore.selected);
  }
  next()
  // if (security.chkLogin(user, to.path)) {
  //   next()
  // } else {
  //   next('/login')
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js